const componente = document.querySelector('#search-form-widget')

const url = 'https://itmx-fractal.s3.eu-west-2.amazonaws.com/exotic/components/preview/booking-result.html'

/**Funciones helpers para transiciones con effecto fade */
function showWithFade(element) {
    element.classList.remove('ocultar')

    requestAnimationFrame(() => {
        element.classList.add('show')
    })
}

function hideWithFade(element) {
    element.classList.remove('show')

    requestAnimationFrame(() => {
        element.classList.add('ocultar')
    })
}

/**Funciones helpers para crear resumenes */
function makeSingleResume() {
    const searchFilterSingle = componente?.querySelector('#search_filter')
    const singleResumen = componente?.querySelector('#single-destination-resume')

    if (searchFilterSingle && singleResumen) {
        /**Inputs */
        const destination = searchFilterSingle.querySelector('#trs_location')
        const nights = searchFilterSingle.querySelector('#checkout_field')
        const date = searchFilterSingle.querySelector('#checkin_field')
        const passenger = searchFilterSingle.querySelector('.packages-passengers')

        /**Span */
        const destinationText = singleResumen.querySelector('.destination-text')
        const dateText = singleResumen.querySelector('.date-text')
        const durationText = singleResumen.querySelector('.duration-text')
        const passengersText = singleResumen.querySelector('.passengers-text')

        destinationText.textContent = destination.value
        if (date.value !== '' && date.value !== '') dateText.textContent = date.value
        if (nights.value !== '' && nights.value !== '') durationText.textContent = nights.value
        passengersText.textContent = passenger.value

        showWithFade(singleResumen)
        hideWithFade(searchFilterSingle)
    }
}


function makeMultipleResume() {
    const searchFilterMultiple = componente?.querySelector('#search_filter-multiple')
    const multipleResume = componente?.querySelector('#multiple-destination-resume')

    if (searchFilterMultiple && multipleResume) {
        /**Inputs */
        const destination = searchFilterMultiple.querySelector('#trs_location-multiple-2')
        const date = searchFilterMultiple.querySelector('#checkin_field-multiple-2')
        const passenger = searchFilterMultiple.querySelector('.packages-passengers')

        /**Span */
        const destinationText = multipleResume.querySelector('.destination-text')
        const dateText = multipleResume.querySelector('.date-text')
        const passengersText = multipleResume.querySelector('.passengers-text')

        destinationText.textContent = destination.value
        if (date.value !== '' && date.value !== '') dateText.textContent = date.value
        passengersText.textContent = passenger.value

        showWithFade(multipleResume)
        hideWithFade(searchFilterMultiple)
    }
}

/**Gestionar evento de submit de formulario de single destination */
const searchFilterSingle = componente?.querySelector('#search_filter')
const editSingleBtn = componente?.querySelector('#edit-single-btn')

searchFilterSingle?.addEventListener('submit', (e) => {
    e.preventDefault()
    makeSingleResume()

    // Demo de navegacion- Solo para la maqueta
    if (window.location.href !== url) window.location.href = url
})

editSingleBtn?.addEventListener('click', () => {
    const searchFilterSingle = componente?.querySelector('#search_filter')
    const singleResumen = componente?.querySelector('#single-destination-resume')

    showWithFade(searchFilterSingle)
    hideWithFade(singleResumen)
})


/**Gestionar estado de submit de form multiple destinations */
const editMultipleBtn = componente?.querySelector('#edit-multiple-btn')
const searchFilterMultiple = componente?.querySelector('#search_filter-multiple')

searchFilterMultiple?.addEventListener('submit', (e) => {
    e.preventDefault()
    makeMultipleResume()

    // Demo de navegacion- Solo para la maqueta
    if (window.location.href !== url) window.location.href = url
})

editMultipleBtn?.addEventListener('click', () => {
    const searchFilterMultiple = componente?.querySelector('#search_filter-multiple')
    const multipleResume = componente?.querySelector('#multiple-destination-resume')

    showWithFade(searchFilterMultiple)
    hideWithFade(multipleResume)
})


